import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import useStyles from './truncated-text.styles.js';

export const TruncatedText = ({ text, className, tooltipPlacement = 'top', maxLength = 29 }) => {
  const classes = useStyles();
  const shouldTruncate = text && text.length > maxLength;

  if (!shouldTruncate) {
    return <span className={className}>{text}</span>;
  }

  const displayText = `${text.substring(0, maxLength)}...`;

  return (
    <Tooltip
      title={text}
      label={displayText}
      placement={tooltipPlacement}
      classes={{ tooltip: classes.tooltip }}
      className={`${classes.tooltipLabel} ${className}`}
    >
      <span className={`${classes.truncatedText}`}>{displayText}</span>
    </Tooltip>
  );
};

TruncatedText.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  maxLength: PropTypes.number
};

export default TruncatedText;
